export const MAX_CHARS = 30
export const CELL_MAX_CHARS = 11

/**
 * Truncates a long name to show the first and last parts separated by an
 * ellipsis in the middle when the name exceeds the maximum length.
 * @param {string} name - The original name
 * @returns The truncated name or original if under MAX_CHARS
 * @example
 * truncateWithMiddleEllipsis('pdfwithaverylongnametotestoverflowverylonglongname.pdf')
 * Returns: 'pdfwithaverylon...onglongname.pdf'
 */
export const truncateWithMiddleEllipsis = (name: string): string => {
  if (name.length <= MAX_CHARS) {
    return name
  }

  const start = name.substring(0, MAX_CHARS / 2)
  const end = name.substring(name.length - MAX_CHARS / 2)

  return `${start}...${end}`
}
